import { useEffect, useState } from "react";
import BrandLogo from "./BrandLogo";

export default function IntroOverlay({ onFinish }) {
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      onFinish();
      return undefined;
    }

    const leaveTimer = window.setTimeout(() => setLeaving(true), 1050);
    const finishTimer = window.setTimeout(onFinish, 1650);

    return () => {
      window.clearTimeout(leaveTimer);
      window.clearTimeout(finishTimer);
    };
  }, [onFinish]);

  return (
    <div
      className={`intro-overlay${leaving ? " is-leaving" : ""}`}
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL || ""}/cream-pattern-seamless-v2.svg)`,
      }}
      aria-hidden="true"
    >
      <BrandLogo className="intro-logo" decorative />
    </div>
  );
}
